<template>
    <div class="page_box">
        <div class="repass_box">
            <div class="repass_left">
                <!--                <img src="../assets/image/left.png" alt="">-->
            </div>
            <div class="repass_right">
                <div class="login_header">
                    <router-link :to="{path:'/login'}">去登录</router-link>
                    <div>
                        <img src="../assets/image/megvii.png" alt="旷视科技" style="height:30px">
                    </div>
                </div>
                <div>
                    <div v-if="repassFlag" class="repass_success">
                        <div>
                            <img src="../assets/image/success2.png" alt="">
                        </div>
                        <p>密码修改成功！</p>
                        <p>点击确认返回登录界面</p>
                        <el-button type="primary" round @click="login" class="mart40">确  认</el-button>
                    </div>
                    <el-form v-else :model="forgetForm" status-icon :rules="forgetRules" ref="forgetForm" class="repass_form" label-width="80px">
                        <el-form-item>
                            <p>请输入邮箱账号获取验证码，进行密码重置。</p>
                        </el-form-item>
                        <el-form-item prop="mail" label="邮箱账号">
                            <el-input placeholder="请输入邮箱" autocomplete name="mail" v-model="forgetForm.mail"></el-input>
                        </el-form-item>
                        <el-form-item prop="code" label="验证码">
                            <el-input placeholder="请输入验证码" v-model="forgetForm.code">
                                <el-button slot="append" @click="getCode">{{valiBtn}}</el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="pass" label="重置密码">
                            <el-input placeholder="输入密码" type="password" v-model="forgetForm.pass"></el-input>
                        </el-form-item>
                        <el-form-item prop="pass2" label="确认密码">
                            <el-input placeholder="再次输入密码" type="password" v-model="forgetForm.pass2"></el-input>
                            <!-- <span class="error">{{errorMsg}}</span> -->
                        </el-form-item>
                        <el-form-item style="margin-top:40px">
                            <el-button type="primary" round @click="submitForm('forgetForm')">确认修改</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getVerificationCodeRe, resetPas} from "../request/api";

    export default {
        name: "rePass",
        data(){
            var validateEmail =(rule, value, callback)=>{
                if(value){
                    let flag=/^[a-zA-Z0-9_.@&-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)
                    if(flag){
                        this.errorMsg=''
                        callback()
                    }else{
                        this.errorMsg='邮箱格式不正确'
                        callback(new Error('邮箱格式不正确'))
                    }
                }else{
                    this.errorMsg=''
                    callback(new Error('输入邮箱'))
                }
            }
            var validPass=(rule, value, callback)=>{
                if(value){
                            let flag1=/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=_-]).{8,}$/.test(value)
                            if(flag1){
                                let flag2=/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=_-]).{8,}$/.test(this.forgetForm.pass2)
                                if(value.trim()===this.forgetForm.pass2.trim()){
                                    if(flag2){
                                        callback()
                                    }
                                    
                                }else {
                                    callback(new Error('两次输入不一致'))
                                }
                            }else{
                                callback(new Error('密码至少8位且包含字母、数字、特殊符号(@#$%^&+=_-)'))
                            }
                }else{
                    callback(new Error('请输入密码'))
                }
            }
            var validPass2=(rule, value, callback)=>{
                if(value){
                            let flag1=/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=_-]).{8,}$/.test(value)
                            if(flag1){
                                let flag2=/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=_-]).{8,}$/.test(this.forgetForm.pass)
                                if(flag2 && value.trim()===this.forgetForm.pass.trim()){
                                    callback()
                                }else{
                                    callback(new Error('两次输入不一致'))
                                }
                            }else{
                                callback(new Error('密码至少8位且包含字母、数字、特殊符号(@#$%^&+=_-)'))
                            }
                }else{
                    callback(new Error('请输入密码'))
                }
            }
            return {
                forgetForm:{
                    mail:'',
                    code:'',
                    pass:'',
                    pass2:''
                },
                forgetRules:{
                    mail: [
                        { validator: validateEmail,required: true, trigger: 'blur' },
                    ],
                    code:[
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                    ],
                    pass:[
                        { validator: validPass,required: true, trigger: 'blur' },
                    ],
                    pass2:[
                        { validator: validPass2,required: true, trigger: 'blur' },
                    ]
                },
                valiBtn:'获取验证码',
                errorMsg:'',
                repassFlag:false,
                timer:null
            }
        },
        methods:{
            getCode(){
                this.$refs.forgetForm.validateField(['mail'], (Error) => {
                    if(!Error){
                        let time = 60;
                        if (!this.timer) {
                            this.timer = setInterval(() => {
                                if (time > 0 && time <= 60) {
                                    time--;
                                    this.valiBtn = time + '秒后重试';
                                } else {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.valiBtn = '发送验证码';
                                }
                            }, 1000)
                            this.queryCode()
                        }
                    }
                })
            },
            queryCode(){
                let data={emailName:this.forgetForm.mail}
                getVerificationCodeRe(data).then(res=>{
                    if(res.data.status!=0){
                        this.$message.error(res.data.msg)
                        clearInterval(this.timer)
                        this.timer=null
                    }
                })
            },
            submitForm(formName){
                this.errorMsg=''
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.forgetForm.pass === this.forgetForm.pass2){
                            let data={
                                emailName:this.forgetForm.mail,
                                passWord:this.forgetForm.pass,
                                code:this.forgetForm.code
                            }
                            resetPas(data).then(res => {
                                if (res.data.status != 0) {
                                    this.$message.error(res.data.msg)
                                    clearInterval(this.timer)
                                    this.timer = null
                                    this.errorMsg=res.data.msg
                                } else {
                                    this.errorMsg=''
                                    this.repassFlag=true
                                }
                            })
                        }else{
                            this.errorMsg='两次输入密码不一致，请重新输入'
                        }
                    }else{
                        return false;
                    }
                });
            },
            login(){
                this.$router.push('/login')
            }
        }
    }
</script>

<style>
    .page_box{
        display: flex;
        justify-content: center;
        align-items: center;
        height:100%;
        background-image: radial-gradient(#4fc3f7d9, #0a36d7);
    }
    .repass_box{
        display: flex;
        width:980px;
        height:560px;
        border-radius: 20px;
        overflow: hidden;
    }
    .repass_left{
        width:50%;
        /*flex:1;*/
        /*min-width:400px;*/
        background:url('../assets/image/left.png') no-repeat center top;
        background-size:cover;
    }
    .repass_right{
        width:50%;
        /*flex:2;*/
        padding:30px 40px;
        background:#fff;
        box-sizing: border-box;
    }
    .login_header{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .repass_form{
        /*width:450px;*/
        margin-top:35px;
    }
    .repass_box .el-form .el-button,.repass_success .el-button{
        width:100%;
    }
    .repass_box .el-form .el-button.is-round,.repass_success .el-button{
        padding:15px 23px;
    }
    .repass_success{
        width:300px;
        margin:100px auto 0;
        text-align: center;
    }
    .repass_success p{
        font-weight:600;
        line-height: 30px;
    }
    .repass_success img{
        width:80px;
        margin-bottom:20px;
    }
    .mart40{
        margin-top:40px;
    }
    .error{
        width:100%;
        color:red;
        position: absolute;
        top:40px;
        left:0;
    }
    input:-internal-autofill-previewed, input:-internal-autofill-selected {
        transition: background-color 5000s ease-in-out 0s !important;
    }
</style>